export default __webpack_public_path__ + "static/media/exghands.43ba65eb.png";